export default __webpack_public_path__ + "static/media/search.38dfc889.png";